module.exports = __webpack_public_path__ + "static/media/defaultRestaurantLogo.6831c4b7.jpg";